function escapeHtmlAttr(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

/** @type {Readonly<Record<string, string>>} */
const EVENTS = Object.freeze({
  LETTER_SIZE: 'letter-size',
  BASEPLATE: 'baseplate',
  VOLUME_LETTERS: 'volume-letters-cta',
  LOCALE: 'locale',
  SEO_LINK: 'seo-link',
  AFFILIATE_AMAZON: 'affiliate-amazon-cta',
  AFFILIATE_RAKUTEN: 'affiliate-rakuten-cta',
});

/**
 * @param {string} eventName
 * @param {Record<string, string | number | boolean | undefined | null>} [data]
 * @returns {string}
 */
function buildUmamiEventAttrs(eventName, data = {}) {
  const attrs = [`data-umami-event="${escapeHtmlAttr(eventName)}"`];
  for (const [key, value] of Object.entries(data)) {
    if (value != null && value !== '') {
      attrs.push(
        `data-umami-event-${escapeHtmlAttr(key)}="${escapeHtmlAttr(String(value))}"`,
      );
    }
  }
  return attrs.join(' ');
}

module.exports = { EVENTS, buildUmamiEventAttrs, escapeHtmlAttr };
